import moment from "moment";
import { useContext, useEffect } from "react";
import { useTheme } from "@mui/material";
import { useAxios } from "../../../../hooks";
import { DateRangePicker, Loader, Paper, Typography } from "../../../../components";
import { formatMoney } from "../../../../utils";
import AuthContext from "../../../../context/auth";
import { sumBy } from "lodash";
import { useFormik } from "formik";

export const ThisMonthBonus = () => {
  const theme = useTheme()
  const { me } = useContext(AuthContext)
  const [dashboard, refetchDashboard] = useAxios(`/bonus?user_id=${me?.id}`, {
    manual: true,
  });

  const searchFormik = useFormik({
    initialValues: {
      from: moment().startOf('month').toDate(),
      to: moment().endOf('month').toDate(),
      user_id: [] as Array<string | number>,
    },
    onSubmit: (values) => {},
  });

  const { values } = searchFormik
  
  useEffect(() => {
    refetchDashboard({
      params: {
        from: values.from,
        to: values.to
      },
    });
  }, [values]);

  console.log(dashboard.data)

  return (
    <Paper
      elevation={1}
      sx={{
        height: "100%",
        padding: 2,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          marginBottom: 10,
          alignItems: "center",
        }}
      >
        <Typography
          component="h2"
          variant="h6"
          color="primary"
          fontSize={20}
          flex={1}
        >
          Comissões 
        </Typography>
        <div
          style={{
            display: "flex",
            flex: 2,
            justifyContent: "space-between",
            gap: 1
          }}
        >
          <div style={{display: 'flex', flex: 2}}>
          <DateRangePicker
            startDate={searchFormik.values.from}
            endDate={searchFormik.values.to}
            onChange={(value) => {
              searchFormik.setFieldValue("from", value.startDate);
              searchFormik.setFieldValue("to", value.endDate);
            }}
          />
          </div>
        </div>
      </div>
      <div
        style={{
          height: "100%",
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        {
          dashboard.loading ? (
            <Loader />
          ) : (
            <Typography variant="h3" color={theme.palette.primary.main}>
              {formatMoney(sumBy(dashboard.data || [], (val: {amount: number}) => Number(val.amount)))}
            </Typography>
          )
        }
      </div>
    </Paper>
  );
};
